//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import bottom from '@/assets/img/bottom.png'

export default {
  name: "reportAdd",
  components: {
    footerNav
  },
  data() {
    return {
      list:[
      ],
      radio:'',
      bottom,
      showPicker:false,
      showPicker1:false,
      color:'',
      tel:'',
      purchaseId:'',
      showPicker: false,
      columns: ['裁剪', '绣花', '印花', '缝制', '后整理'],
      value:''
    }
  },
  created() {
    if(this.$route.params&&this.$route.params.arr){
      this.list=this.list.concat(this.$route.params.arr)
    }
  },
  mounted() {
  },
  methods: {
    onConfirm(value) {
      this.color = value;
      this.showPicker = false;
    },
    toEdit(){
      this.$router.push({name:'productCertificateEdit'})
    },
    next(){
      this.$router.push({name:'report'})
    },
    chooseConfirm(){
      this.purchaseId = 78954727524120576
      this.showPicker1=false
    },
    onSearch(){

    },
    toAddRow(){
      this.$router.push({name:'reportRowAdd'})
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/report/add.vue